import {
  useGetCustomerHealthDataQuery,
  useGetHealthHeatMapDataQuery,
  useGetCustomerHealthProductTrendDataQuery,
  useGetTPIDCustomerHealthDataQuery,
  useGetTPIDHealthHeatMapDataQuery,
  useGetTPIDCustomerHealthProductTrendDataQuery
} from "../../../slices/ExploreHealth.slice";

export type HealthViewMode = "tenant" | "tpid";

export function useCustomerHealthData(id: string, productFamily: string, viewMode: HealthViewMode) {
  const tenantResult = useGetCustomerHealthDataQuery([id, productFamily], { skip: viewMode === "tpid" });
  const tpidResult = useGetTPIDCustomerHealthDataQuery([id, productFamily], { skip: viewMode === "tenant" });
  return viewMode === "tpid" ? tpidResult : tenantResult;
}

export function useHealthHeatMapData(id: string, productFamily: string, viewMode: HealthViewMode) {
  const tenantResult = useGetHealthHeatMapDataQuery([id, productFamily], { skip: viewMode === "tpid" || !id });
  const tpidResult = useGetTPIDHealthHeatMapDataQuery([id, productFamily], { skip: viewMode === "tenant" || !id });
  return viewMode === "tpid" ? tpidResult : tenantResult;
}

export function useCustomerHealthProductTrendData(id: string, productFamily: string, numberOfMonths: number, viewMode: HealthViewMode) {
  const tenantResult = useGetCustomerHealthProductTrendDataQuery([id, productFamily, numberOfMonths], { skip: viewMode === "tpid" });
  const tpidResult = useGetTPIDCustomerHealthProductTrendDataQuery([id, productFamily, numberOfMonths], { skip: viewMode === "tenant" });
  return viewMode === "tpid" ? tpidResult : tenantResult;
}
